module.exports = __webpack_public_path__ + "img/chevron-down.088be403.svg";